import * as localizationKeys from '../../../consts/localization/localizationKeys';
import connectivityService from '../../../services/device/connectivityService';
import pairingGuidePageService from '../../../services/pairingGuidePageService';

const getPairingErrorButtonKeys = (deviceType) => {
    const {mainButtonProp, secondaryButtonProp, tertiaryButtonProp} = pairingGuidePageService.getPairingButtonProp({
        usbProp: localizationKeys.CONNECTION_FAIL_USB_TRY_AGAIN_BUTTON,
        bleProp: localizationKeys.CONNECTION_FAIL_BLE_TRY_AGAIN_BUTTON,
        commonProp: localizationKeys.PAIR_FAIL_TRY_AGAIN_BUTTON,
        cancelProp: localizationKeys.PAIR_FAIL_SKIP_BUTTON,
        deviceType,
    });

    return {
        mainButtonText: mainButtonProp,
        secondaryButtonText: secondaryButtonProp,
        tertiaryButtonText: tertiaryButtonProp,
    };
};

const getConnectionErrorButtonKeys = (deviceType) => {
    const {mainButtonProp, secondaryButtonProp, tertiaryButtonProp} = pairingGuidePageService.getPairingButtonProp({
        usbProp: localizationKeys.CONNECTION_FAIL_USB_TRY_AGAIN_BUTTON,
        bleProp: localizationKeys.CONNECTION_FAIL_BLE_TRY_AGAIN_BUTTON,
        commonProp: localizationKeys.PAIR_DEVICE_NO_BLE_FOUNDED_TRY_AGAIN_TEXT,
        cancelProp: localizationKeys.PAIR_DEVICE_NO_BLE_FOUNDED_SKIP_TEXT,
        deviceType,
    });

    return {
        mainButtonText: mainButtonProp,
        secondaryButtonText: secondaryButtonProp,
        tertiaryButtonText: tertiaryButtonProp,
    };
};

const pairingGuideErrorsContent = (deviceType) => {
    const isBle = connectivityService.isBle();

    return {
        PAIRING_ERRORS: {
            title: isBle ? localizationKeys.BLE_PAIRING_FAIL_TITLE : localizationKeys.USB_PAIRING_FAIL_TITLE,
            description: isBle ? localizationKeys.BLE_PAIRING_FAIL_MESSAGE : localizationKeys.USB_PAIRING_FAIL_MESSAGE,
            subtitleText: localizationKeys.PAIRING_FAIL_SUB_TITLE,
            ...getPairingErrorButtonKeys(deviceType),
        },
        CONNECTION_ERRORS: {
            title: localizationKeys.PAIRING_FAIL_DESCRIPTION,
            description: isBle
                ? localizationKeys.PAIRING_TROUBLESHOOTING_TEXT
                : localizationKeys.USB_PAIRING_TROUBLESHOOTING_TEXT,
            subtitleText: localizationKeys.PAIR_DEVICE_NO_BLE_FOUNDED_SUB_TITLE,
            ...getConnectionErrorButtonKeys(deviceType),
        },
        DEVICE_SUPPORT_FAILED_ERRORS: {
            title: localizationKeys.PAIRING_UNABLE_DEVICE_NOT_SUPPORTED_TITLE,
            description: localizationKeys.PAIRING_UNABLE_DEVICE_NOT_SUPPORTED_MESSAGE,
            mainButtonText: localizationKeys.PAIRING_UNABLE_DEVICE_NOT_SUPPORTED_TRY_AGAIN_BUTTON,
            secondaryButtonText: localizationKeys.PAIRING_UNABLE_DEVICE_NOT_SUPPORTED_SKIP_BUTTON,
            subtitleText: localizationKeys.PAIRING_UNABLE_DEVICE_NOT_SUPPORTED_SUB_TITLE,
        },
        WRONG_DEVICE_ERRORS: {
            //TODO: add description if p1 support will be added for GAM
            DEV_TYPE_V24P_CHARGER: {
                title: localizationKeys.PAIRING_FAIL_DESCRIPTION,
            },
            DEV_TYPE_P1V30_CHARGER: {
                title: localizationKeys.PAIRING_FAIL_DESCRIPTION,
            },
            DEV_TYPE_P1V31_CHARGER: {
                title: localizationKeys.PAIRING_FAIL_DESCRIPTION,
            },
            DEV_TYPE_P1V31_ORIGINALS_CHARGER: {
                title: localizationKeys.PAIRING_FAIL_DESCRIPTION,
            },
            DEV_TYPE_P1V30M: {
                title: localizationKeys.PAIRING_FAIL_DESCRIPTION,
            },
            DEV_TYPE_P1V31M: {
                title: localizationKeys.PAIRING_FAIL_DESCRIPTION,
            },
            DEV_TYPE_P4_M3_G2: {
                title: localizationKeys.PAIRING_FAIL_DESCRIPTION,
                description: localizationKeys.PAIRING_WRONG_DEVICE_FAIL_MESSAGE,
            },
            DEV_TYPE_P1V40V_CHARGER: {
                title: localizationKeys.PAIRING_FAIL_DESCRIPTION,
                description: localizationKeys.PAIRING_WRONG_DEVICE_FAIL_MESSAGE_P1V40,
            },
            DEV_TYPE_P1V40C_CHARGER: {
                title: localizationKeys.PAIRING_FAIL_DESCRIPTION,
                description: localizationKeys.PAIRING_WRONG_DEVICE_FAIL_MESSAGE_P1V40,
            },
            DEV_TYPE_P1V40D_CONTROL: {
                title: localizationKeys.PAIRING_FAIL_DESCRIPTION,
                description: localizationKeys.PAIRING_WRONG_DEVICE_FAIL_MESSAGE_P1V40,
            },
            mainButtonText: localizationKeys.PAIRING_UNABLE_DEVICE_NOT_SUPPORTED_TRY_AGAIN_BUTTON,
            secondaryButtonText: localizationKeys.PAIRING_UNABLE_DEVICE_NOT_SUPPORTED_SKIP_BUTTON,
            subtitleText: localizationKeys.PAIRING_UNABLE_DEVICE_NOT_SUPPORTED_SUB_TITLE,
        },
    };
};

export {pairingGuideErrorsContent};
